// removed by extract-text-webpack-plugin
module.exports = {"Row":"_3pVl2Ndl3lCnGMTeDvlnnG","Category":"_2353nhrLeE4M4Hd99_V_R-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Courses/Courses.css
// module id = 402
// module chunks = 0